let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("df3DW")).then(() => parcelRequire('lzohJ'));